import { formatCurrency, formatDate } from '../helpers/formatters';
import { useLang } from '../hooks/useLanguage';
import AmountWithFee from './AmountWithFee';

interface Transaction {
    id: string | number;
    createdAt: string | Date;
    finished: boolean;
    paymentType: string;
    amount: number;
    processingFee?: number;
    paymentInfo?: {
        card?: { brand?: string | null; last4?: string | null } | null;
    } | null;
}

function TransactionInfo({
    transaction,
    paymentMethod,
}: {
    transaction: Transaction;
    // can be undefined as well
    paymentMethod: any | undefined;
}) {
    const { getI18n, t } = useLang();

    const statusText = transaction.finished
        ? t('widgetReservationInfo.transaction.statusValues.finished')
        : t('widgetReservationInfo.transaction.statusValues.pending');

    return (
        <tr>
            <th
                className="fireknife-text-start"
                aria-label={t('widgetReservationInfo.transaction.transactionId')}
            >
                #{transaction.id}
            </th>
            <td
                className="fireknife-text-start"
                aria-label={t('widgetReservationInfo.transaction.status')}
            >
                <span
                    className={
                        `fireknife-transactions__status ` +
                        (transaction.finished
                            ? 'fireknife-transactions__status--finished'
                            : 'fireknife-transactions__status--processing')
                    }
                >
                    {statusText}
                </span>
            </td>
            <td
                className="fireknife-text-start"
                aria-label={t('widgetReservationInfo.transaction.paymentMethod')}
            >
                <span className="fireknife-transactions__badge">
                    {transaction.paymentType === 'coupon' && transaction.amount < 0
                        ? t('widgetReservationInfo.transaction.discountReversalLabel')
                        : paymentMethod !== undefined
                          ? getI18n(paymentMethod.name, paymentMethod.nameI18n)
                          : transaction.paymentType}
                </span>
                {transaction.paymentInfo?.card?.last4 && (
                    <span
                        className="fireknife-transactions__card-hint"
                        style={{ marginLeft: 8, color: '#555', fontSize: '0.85em' }}
                    >
                        {transaction.paymentInfo.card.brand
                            ? `${transaction.paymentInfo.card.brand} ****${transaction.paymentInfo.card.last4}`
                            : `****${transaction.paymentInfo.card.last4}`}
                    </span>
                )}
            </td>
            <td
                className="fireknife-text-start"
                aria-label={t('widgetReservationInfo.transaction.date')}
            >
                {formatDate(transaction.createdAt, t('widgetLocale'))}
            </td>
            <td
                className="fireknife-text-end"
                aria-label={t('widgetReservationInfo.transaction.amount')}
            >
                <strong>{formatCurrency(transaction.amount / 100)}</strong>
                <AmountWithFee
                    amount={transaction.amount}
                    fee={transaction.processingFee || 0}
                />
            </td>
        </tr>
    );
}

export default TransactionInfo;
